import {DataSource} from "@angular/cdk/collections";
import {BehaviorSubject, Observable} from "rxjs";

export class DigitalCertificateCloudCa {
  id: string;
  certificateName: string;
  serialNumber: string;
  taxCode: string;
  activeDate: string;
  expireDate: string;
  isUsed: boolean;
  isExtend: boolean;
  checked: boolean;
  signAlgo: string;
  issuedBy: string;
  distinguishedName: string;
  credentialId: string;
  cloudCaUserId: string;
  certificates: Array<string>;
}

export class DigitalCertificateCloudCaDataSource extends DataSource<DigitalCertificateCloudCa> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<DigitalCertificateCloudCa[]>([]);

  constructor() {
    super();
  }


  setData(data: DigitalCertificateCloudCa[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<DigitalCertificateCloudCa[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
}
